import breakpoints from '../config/breakpoints'
import { getCitrusUrl } from '../helpers/GetCitrusUrl'
import CitrusHelper from '../helpers/CitrusHelper'
import mergePdpDataToCitrus from '../helpers/MergePdpDataToCitrus'
import citrusService from '../services/CitrusService'
import beaconService from '../services/BeaconService'
import { get } from '../utils/PolyfillLodash'
import { clearCitrusProducts, handleCitrus, showCitrusProducts } from '../redux/citrus/citrus'

import Logger from '../utils/Logger'

const logger = new Logger()

const getPlatform = function getPlatform() {
  return window.matchMedia(breakpoints.small).matches ? 'web' : 'mobile'
}

const getMaxNumberOfAds = () => {
  return getPlatform() === 'web' ? 3 : 2
}

const getExtraFilters = appliedFilters => {
  if (!(appliedFilters && appliedFilters.length)) {
    return
  }

  const formattedFilters = appliedFilters
    .filter(filter => filter.id !== 'category')
    .map(filter => {
      return filter.values.map(value => {
        const filterId = filter.id === 'brands' ? 'brand' : filter.id
        return `${filterId}:${value}`
      })
    })

  return formattedFilters
}

const hasUnsupportedFilters = appliedFilters => {
  if (!(appliedFilters && appliedFilters.length)) {
    return
  }

  const unuspportedFilters = [] // Add filters not supported by Citrus here

  return appliedFilters.filter(filter => unuspportedFilters.includes(filter.id)).length > 0
}

const getPartNumbers = citrusResponse => {
  return get(citrusResponse, 'body.ads', [])
    .map(v => {
      return v.gtin
    })
    .join(',')
}

const isCitrusResponseValid = res => {
  return get(res, 'body.ads') && Array.isArray(res.body.ads) && res.body.ads.length > 0
}

const isPdpResponseValid = res =>
  res.data && ((res.data.length > 0 && res.data[0].type === 'products') || res.data.type === 'products')

const isProdListValid = productList => {
  return (
    (getPlatform() === 'web' && CitrusHelper.isProdListDesktopValid(productList)) ||
    (getPlatform() === 'mobile' && CitrusHelper.isProdListMobileTabletValid(productList))
  )
}

const normalizeCitrusResponseData = data => {
  const myProductData = get(data, 'ads')
  return {
    body: {
      PageBeacon: get(data, 'PageBeacon', ''),
      ads: myProductData
    }
  }
}

const fireBeacon = response => {
  if (response && response.body && response.body.PageBeacon) {
    beaconService(response.body.PageBeacon)
  }
}

const enrichProductData = (context, response) => {
  const partNumbers = getPartNumbers(response)
  context.service.read('pdp', { partNumbers }, {}, (error, pdpResponse) => {
    if (error || !isPdpResponseValid(pdpResponse)) {
      return context.reduxStore.dispatch(clearCitrusProducts())
    }
    const hlData = mergePdpDataToCitrus({ response, pdpResponse })
    const ads = get(hlData, 'ads', [])
    if (!isProdListValid(ads)) {
      return context.reduxStore.dispatch(clearCitrusProducts())
    }
    return context.reduxStore.dispatch(handleCitrus(hlData))
  })
}

const showSkeletonLoaders = (context, response) => {
  const body = get(response, 'body', {})
  const products = body.ads || body.ProductAd
  if (products) {
    products.forEach(product => {
      product.Price = null
    })
    context.reduxStore.dispatch(handleCitrus({ ads: products }))
  }
}

export default function executeCitrus(actionContext, payload) {
  const extraFilters = getExtraFilters(payload.appliedFilters)
  const AMCV_MATCH = /AMCV_[0-9A-Z%]+AdobeOrg=([0-9a-zA-Z%\-_]+)/g.exec(document.cookie)
  const S_VI_MATCH = /s_vi=([0-9a-zA-Z%\-|[\]]+)/g.exec(document.cookie)
  const userid = S_VI_MATCH ? S_VI_MATCH[1] : AMCV_MATCH ? AMCV_MATCH[1] : null
  const requestBody = {
    sessionId: decodeURIComponent(userid),
    catalogId: window.citrusCatalogId,
    maxNumberOfAds: getMaxNumberOfAds(),
    productFilters: extraFilters || [],
    options: {
      filterMode: 'AndOr'
    }
  }

  if (payload.pageType === 'browse') {
    requestBody.placement = 'category-only'
    requestBody.productFilters.push([`taxonomy:${payload.currentCategory.name.toLowerCase()}`])
  }

  if (payload.pageType === 'search' || payload.pageType === 'canned' || payload.pageType === 'directory') {
    requestBody.placement = 'search-only'
    requestBody.searchTerm = payload.keyword
  }

  const citrusUrl = getCitrusUrl()
  return citrusService(citrusUrl, requestBody)
    .then(response => {
      const citrusResponse = normalizeCitrusResponseData(response)
      fireBeacon(citrusResponse)
      // clear citrus for certain filter combinations
      if (hasUnsupportedFilters(payload.appliedFilters)) {
        return actionContext.reduxStore.dispatch(clearCitrusProducts())
      }
      // continue if citrus response valid and if it has 3 results for desktop, 2 mobile
      if (isCitrusResponseValid(citrusResponse) && isProdListValid(get(citrusResponse, 'body.ads', []))) {
        actionContext.reduxStore.dispatch(showCitrusProducts())
        showSkeletonLoaders(actionContext, citrusResponse)
        const newData = enrichProductData(actionContext, citrusResponse)
        return newData
      }
      return actionContext.reduxStore.dispatch(clearCitrusProducts())
    })
    .catch(err => {
      logger.error('apiLogger', err, 'Unable to fetch Citrus.')
      return actionContext.reduxStore.dispatch(clearCitrusProducts())
    })
}
